export * from './useInfiniteIndexQuery.types';
export { default as useInfiniteIndexQuery } from './useInfiniteIndexQuery';
